const info_provinces = [
  {
    value: "X",
    label: "Córdoba",
    officeName: "Córdoba",
    eccoSA: true,
    withOffice: true,
    idAdminMop: 2,
    planAdi: 206606,
    provId: "6",
    onlyThisLocalities: [
      {
        value: "20060",
        label: "Córdoba",
        domicilio: {
          provincia: "CORDOBA",
          partido: "CAPITAL",
          localidad: "CORDOBA",
          provinciaId: "6",        
          partidoId: "193",        
          localidadId: "4202"
       }
      }
    ]
  },
  {
    value: "M",
    label: "Mendoza",
    officeName: "Mendoza",
    eccoSA: true,
    withOffice: true,
    idAdminMop: 7,
    planAdi: 800922,
    provId: "13",
    onlyThisLocalities: [
      {
        value: "11949",
        label: "Godoy Cruz",
        domicilio: {
          provincia: "MENDOZA",
          partido: "GODOY CRUZ",
          localidad: "GODOY CRUZ",
          provinciaId: "13",        
          partidoId: "328",        
          localidadId: "10973" 
        }
      },
      {
        value: "11973",
        label: "Guaymallen",
        domicilio: {
          provincia: "MENDOZA",
          partido: "GUAYMALLEN",
          localidad: "BERMEJO",
          provinciaId: "13",        
          partidoId: "329",        
          localidadId: "10976" 
        }
      },
      {
        value: "12341",
        label: "Las Heras",
        domicilio: {
          provincia: "MENDOZA",
          partido: "LAS HERAS",
          localidad: "LAS HERAS",
          provinciaId: "13",        
          partidoId: "332",        
          localidadId: "11366" 
        }
      },
      {
        value: "12544",
        label: "Lujan de cuyo",
        domicilio: {
          provincia: "MENDOZA",
          partido: "LUJAN DE CUYO",
          localidad: "LUJAN DE CUYO",
          provinciaId: "13",        
          partidoId: "334",        
          localidadId: "11567" 
        }
      },
      {
        value: "12581",
        label: "Maipú",
        domicilio: {
          provincia: "MENDOZA",
          partido: "MAIPU",
          localidad: "MAIPU",
          provinciaId: "13",        
          partidoId: "335",        
          localidadId: "11604" 
        }
      }
    ]
  },
  {
    value: "Q",
    label: "Neuquén",
    officeName: "Neuquén",
    eccoSA: true,
    withOffice: true,
    idAdminMop: 3,
    planAdi: 301549,
    provId: "15",
    onlyThisLocalities: [
      {
        value: "14464",
        label: "Centenario",
        domicilio: {
          provincia: "NEUQUÉN",
          partido: "CONFLUENCIA",
          localidad: "CENTENARIO",
          provinciaId: "15",        
          partidoId: "366",        
          localidadId: "13010" 
        }
      },
      {
        value: "14473",
        label: "Neuquén",
        domicilio: {
          provincia: "NEUQUÉN",
          partido: "CONFLUENCIA",
          localidad: "NEUQUÉN",
          provinciaId: "15",        
          partidoId: "366",        
          localidadId: "13017" 
        }
      }
    ]
  },
  {
    value: "QS",
    label: "Río Negro",
    officeName: "Neuquén",
    eccoSA: true,
    withOffice: true,
    idAdminMop: 3,
    planAdi: 301549,
    provId: "17",
    onlyThisLocalities: [
      {
        value: "14486",
        label: "Cipolletti",
        domicilio: {
          provincia: "RÍO NEGRO",
          partido: "GENERAL ROCA",
          localidad: "CIPOLLETTI",
          provinciaId: "17",        
          partidoId: "385",        
          localidadId: "13495" 
        }
      },
    ]
  },  
  {
    value: "A",
    label: "Salta",
    officeName: "Salta",
    eccoSA: true,
    withOffice: true,
    idAdminMop: 5,
    planAdi: 502573,
    provId: "18",
    onlyThisLocalities: [
      {
        value: "226",
        label: "Cerrillos",
        domicilio: {
          provincia: "SALTA",
          partido: "CERRILLOS",
          localidad: "CERRILLOS",
          provinciaId: "18",        
          partidoId: "395",        
          localidadId: "13849" 
        }
      },
      {
        value: "223",
        label: "Salta",
        domicilio: {
          provincia: "SALTA",
          partido: "SALTA",
          localidad: "SALTA",
          provinciaId: "18",        
          partidoId: "394",        
          localidadId: "13846" 
        }
      },
      {
        value: "224",
        label: "San lorenzo",
        domicilio: {
          provincia: "SALTA",
          partido: "SALTA",
          localidad: "SAN LORENZO",
          provinciaId: "18",        
          partidoId: "394",        
          localidadId: "13847" 
        }
      },
      {
        value: "112",
        label: "San luis",
        domicilio: {
          provincia: "SALTA",
          partido: "ROSARIO DE LA FRONTERA",
          localidad: "SAN LUIS",
          provinciaId: "18",        
          partidoId: "410",        
          localidadId: "14719" 
        }
      },
      {
        value: "577",
        label: "Vaqueros",
        domicilio: {
          provincia: "SALTA",
          partido: "LA CALDERA",
          localidad: "VAQUEROS",
          provinciaId: "18",        
          partidoId: "401",        
          localidadId: "14202"
         }
      }
    ]
  },
  {
    value: "S",
    label: "Santa Fe",
    officeName: "Santa Fe",
    eccoSA: true,
    withOffice: true,
    idAdminMop: 4,
    planAdi: 410594,
    provId: "22",
    onlyThisLocalities: [
      {
        value: "15725",
        label: "Funes",
        domicilio: {
          provincia: "SANTA FE",
          partido: "ROSARIO",
          localidad: "FUNES",
          provinciaId: "22",        
          partidoId: "460",        
          localidadId: "17773" 
        }
      },
      {
        value: "15965",
        label: "Roldán",
        domicilio: {
          provincia: "SANTA FE",
          partido: "SAN LORENZO",
          localidad: "ROLDAN",
          provinciaId: "22",        
          partidoId: "465",        
          localidadId: "18010" 
        }
      },
      {
        value: "15742",
        label: "Rosario",
        domicilio: {
          provincia: "SANTA FE",
          partido: "ROSARIO",
          localidad: "ROSARIO",
          provinciaId: "22",        
          partidoId: "460",        
          localidadId: "17790" 
        }
      },
      {
        value: "15749",
        label: "Villa Gobernador Gálvez",
        domicilio: {
          provincia: "SANTA FE",
          partido: "ROSARIO",
          localidad: "VILLA GOBERNADOR GÁLVEZ",
          provinciaId: "22",        
          partidoId: "460",        
          localidadId: "17797" 
        }
      },
      {
        value: "15729",
        label: "Ibarlucea",
        domicilio: {
          provincia: "SANTA FE",
          partido: "ROSARIO",
          localidad: "IBARLUCEA",
          provinciaId: "22",        
          partidoId: "460",        
          localidadId: "17777" 
        }
      }
    ]
  },
  {
    value: "T",
    label: "Tucumán",
    officeName: "Tucumán",
    eccoSA: true,
    withOffice: true,
    idAdminMop: 6,
    planAdi: 603112,
    provId: "25",
    onlyThisLocalities: [
      {
        value: "16385",
        label: "Alderetes",
        domicilio: {
          provincia: "TUCUMÁN",
          partido: "CRUZ ALTA",
          localidad: "ALDERETES",
          provinciaId: "25",        
          partidoId: "502",        
          localidadId: "21039" 
        }
      },
      {
        value: "16391",
        label: "Banda del Río Sali",
        domicilio: {
          provincia: "TUCUMÁN",
          partido: "CRUZ ALTA",
          localidad: "BANDA DEL RÍO SALI",
          provinciaId: "25",        
          partidoId: "502",        
          localidadId: "21045"
         }
      },
      {
        value: "18029",
        label: "Las Talitas",
        domicilio: {
          provincia: "TUCUMÁN",
          partido: "TAFI VIEJO",
          localidad: "LAS TALITAS",
          provinciaId: "25",        
          partidoId: "513",        
          localidadId: "22573" 
        }
      },
      {
        value: "16779",
        label: "Manantial",
        domicilio: {
          provincia: "TUCUMÁN",
          partido: "LULES",
          localidad: "MANANTIAL",
          provinciaId: "25",        
          partidoId: "508",        
          localidadId: "22712"
         }
      },
      {
        value: "16534",
        label: "Los Gutiérrez",
        domicilio: {
          provincia: "TUCUMÁN",
          partido: "CRUZ ALTA",
          localidad: "LOS GUTIÉRREZ",
          provinciaId: "25",        
          partidoId: "502",        
          localidadId: "21188" 
        }
      },
      {
        value: "16378",
        label: "San Miguel de Tucumán",
        domicilio: {
          provincia: "TUCUMÁN",
          partido: "SAN MIGUEL DE TUCUMÁN",
          localidad: "SAN MIGUEL DE TUCUMÁN",
          provinciaId: "25",        
          partidoId: "500",        
          localidadId: "20921" 
        }
      },
      {
        value: "18047",
        label: "Tafi viejo",
        domicilio: {
          provincia: "TUCUMÁN",
          partido: "TAFI VIEJO",
          localidad: "TAFI VIEJO",
          provinciaId: "25",        
          partidoId: "513",        
          localidadId: "22591" 
        }
      },
      {
        value: "18262",
        label: "Yerba Buena",
        domicilio: {
          provincia: "TUCUMÁN",
          partido: "YERBA BUENA",
          localidad: "YERBA BUENA",
          provinciaId: "25",        
          partidoId: "515",        
          localidadId: "22805" 
        }
      }
    ]
  },
  {
    value: "B",
    label: "Buenos Aires",
    officeName: "Buenos Aires",
    eccoSA: false,
    withOffice: true,
    idAdminMop: 1,
    planAdi: 104586,
    provId: "1",
    onlyThisLocalities: [
      {
        value: "6",
        label: "Almirante Brown",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "ALMIRANTE BROWN",
          localidad: "ADROGUÉ",
          provinciaId: "1",        
          partidoId: "6",        
          localidadId: "140" 
        }
      },
      {
        value: "8",
        label: "Avellaneda",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "AVELLANEDA",
          localidad: "AVELLANEDA",
          provinciaId: "1",        
          partidoId: "8",        
          localidadId: "162" 
        }
      },
      {
        value: "15",
        label: "Berazatagui",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "BERAZATEGUI",
          localidad: "BERAZATEGUI",
          provinciaId: "1",        
          partidoId: "15",        
          localidadId: "307" 
        }
      },
      {
        value: "16",
        label: "Berisso",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "BERISSO",
          localidad: "BERISSO",
          provinciaId: "1",        
          partidoId: "16",        
          localidadId: "318" 
        }
      },
      {
        value: "30",
        label: "Brandsen",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "BRANDSEN",
          localidad: "BRANDSEN",
          provinciaId: "1",        
          partidoId: "30",        
          localidadId: "540" 
        }
      },
      {
        value: "20",
        label: "Cañuelas",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "CAÑUELAS",
          localidad: "CAÑUELAS",
          provinciaId: "1",        
          partidoId: "20",        
          localidadId: "375" 
        }
      },
      {
        value: "38",
        label: "Ensenada",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "ENSENADA",
          localidad: "ENSENADA",
          provinciaId: "1",        
          partidoId: "38",        
          localidadId: "676" 
        }
      },
      {
        value: "39",
        label: "Escobar",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "ESCOBAR",
          localidad: "ESCOBAR",
          provinciaId: "1",        
          partidoId: "39",        
          localidadId: "688" 
        }
      },
      {
        value: "40",
        label: "Esteban Echeverría",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "ESTEBAN ECHEVERRÍA",
          localidad: "MONTE GRANDE",
          provinciaId: "1",        
          partidoId: "40",        
          localidadId: "704" 
        }
      },
      {
        value: "41",
        label: "Exaltación de la Cruz",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "EXALTACIÓN DE LA CRUZ",
          localidad: "CAPILLA DEL SEÑOR",
          provinciaId: "1",        
          partidoId: "41",        
          localidadId: "707" 
        }
      },
      {
        value: "42",
        label: "Ezeiza",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "EZEIZA",
          localidad: "EZEIZA",
          provinciaId: "1",        
          partidoId: "42",        
          localidadId: "726" 
        }
      },
      {
        value: "43",
        label: "Florencio Varela",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "FLORENCIO VARELA",
          localidad: "FLORENCIO VARELA",
          provinciaId: "1",        
          partidoId: "43",        
          localidadId: "730" 
        }
      },
      {
        value: "51",
        label: "General Las Heras",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "GENERAL LAS HERAS",
          localidad: "GENERAL LAS HERAS",
          provinciaId: "1",        
          partidoId: "51",        
          localidadId: "836" 
        }
      },
      {
        value: "58",
        label: "General San Martín",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "GENERAL SAN MARTÍN",
          localidad: "GENERAL SAN MARTÍN",
          provinciaId: "1",        
          partidoId: "58",        
          localidadId: "928" 
        }
      },
      {
        value: "63",
        label: "Hurlingham",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "HURLINGHAM",
          localidad: "HURLINGHAM",
          provinciaId: "1",        
          partidoId: "63",        
          localidadId: "1008" 
        }
      },
      {
        value: "64",
        label: "Ituzaingó",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "ITUZAINGÓ",
          localidad: "ITUZAINGÓ",
          provinciaId: "1",        
          partidoId: "64",        
          localidadId: "1011" 
        }
      },
      {
        value: "65",
        label: "José C. Paz",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "JOSÉ C. PAZ",
          localidad: "JOSÉ C. PAZ",
          provinciaId: "1",        
          partidoId: "65",        
          localidadId: "1013" 
        }
      },
      {
        value: "67",
        label: "La Matanza",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "LA MATANZA",
          localidad: "SAN JUSTO",
          provinciaId: "1",        
          partidoId: "67",        
          localidadId: "1074" 
        }
      },
      {
        value: "69",
        label: "Lanús",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "LANÚS",
          localidad: "LANÚS",
          provinciaId: "1",        
          partidoId: "69",        
          localidadId: "1075" 
        }
      },
      {
        value: "76",
        label: "Lomas de Zamora",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "LOMAS DE ZAMORA",
          localidad: "LOMAS DE ZAMORA",
          provinciaId: "1",        
          partidoId: "76",        
          localidadId: "1177" 
        }
      },
      {
        value: "82",
        label: "Marcos Paz",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "MARCOS PAZ",
          localidad: "MARCOS PAZ",
          provinciaId: "1",        
          partidoId: "82",        
          localidadId: "1280" 
        }
      },
      {
        value: "80",
        label: "Malvinas Argentinas",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "MALVINAS ARGENTINAS",
          localidad: "LOS POLVORINES",
          provinciaId: "1",        
          partidoId: "80",        
          localidadId: "1242" 
        }
      },
      {
        value: "87",
        label: "Moreno",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "MORENO",
          localidad: "MORENO",
          provinciaId: "1",        
          partidoId: "87",        
          localidadId: "1329" 
        }
      },
      {
        value: "84",
        label: "Merlo",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "MERLO",
          localidad: "MERLO",
          provinciaId: "1",        
          partidoId: "84",        
          localidadId: "1306" 
        }
      },
      {
        value: "88",
        label: "Morón",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "MORÓN",
          localidad: "MORÓN",
          provinciaId: "1",        
          partidoId: "88",        
          localidadId: "1335" 
        }
      },
      {
        value: "97",
        label: "Pilar",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "PILAR",
          localidad: "PILAR",
          provinciaId: "1",        
          partidoId: "97",        
          localidadId: "1578" 
        }
      },
      {
        value: "99",
        label: "Presidente Perón",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "PRESIDENTE PERÓN",
          localidad: "GUERNICA",
          provinciaId: "1",        
          partidoId: "99",        
          localidadId: "1598" 
        }
      },
      {
        value: "102",
        label: "Quilmes",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "QUILMES",
          localidad: "QUILMES",
          provinciaId: "1",        
          partidoId: "102",        
          localidadId: "1649" 
        }
      },
      {
        value: "115",
        label: "San Fernando",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "SAN FERNANDO",
          localidad: "SAN FERNANDO",
          provinciaId: "1",        
          partidoId: "115",        
          localidadId: "1826" 
        }
      },
      {
        value: "116",
        label: "San Isidro",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "SAN ISIDRO",
          localidad: "SAN ISIDRO",
          provinciaId: "1",        
          partidoId: "116",        
          localidadId: "1834" 
        }
      },
      {
        value: "117",
        label: "San Miguel",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "SAN MIGUEL",
          localidad: "SAN MIGUEL",
          provinciaId: "1",        
          partidoId: "117",        
          localidadId: "1839" 
        }
      },
      {
        value: "120",
        label: "San Vicente",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "SAN VICENTE",
          localidad: "SAN VICENTE",
          provinciaId: "1",        
          partidoId: "120",        
          localidadId: "1877" 
        }
      },
      {
        value: "124",
        label: "Tigre",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "TIGRE",
          localidad: "TIGRE",
          provinciaId: "1",        
          partidoId: "124",        
          localidadId: "1939" 
        }
      },
      {
        value: "129",
        label: "Tres de Febrero",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "TRES DE FEBRERO",
          localidad: "CASEROS",
          provinciaId: "1",        
          partidoId: "129",        
          localidadId: "2013" 
        }
      },
      {
        value: "131",
        label: "Vicente López",
        domicilio: {
          provincia: "BUENOS AIRES",
          partido: "VICENTE LÓPEZ",
          localidad: "VICENTE LÓPEZ",
          provinciaId: "1",        
          partidoId: "131",        
          localidadId: "2036" 
        }
      }
    ]
  },
  {
    value: "BC",
    label: "Capital Federal",
    officeName: "Capital Federal",
    eccoSA: false,
    withOffice: false,
    idAdminMop: 1,
    planAdi: 104586,
    provId: "2",
    onlyThisLocalities: [
      {
        value: "135",
        label: "Ciudad Autónoma Buenos Aires",
        domicilio: {
          provincia: "CAPITAL FEDERAL",
          partido: "CAPITAL FEDERAL",
          localidad: "CIUDAD AUTONOMA BUENOS AIRES",
          provinciaId: "2",        
          partidoId: "135",        
          localidadId: "2102" 
        }
      }
    ]
  },
  {
    value: "D",
    label: "San Luis",
    officeName: "San Luis",
    eccoSA: false,
    withOffice: false,
    provId: "20",
    onlyThisLocalities: []
  },
  {
    value: "E",
    label: "Entre ríos",
    officeName: "Entre ríos",
    eccoSA: false,
    withOffice: false,
    provId: "8",
    onlyThisLocalities: []
  },
  {
    value: "F",
    label: "La Rioja",
    officeName: "La Rioja",
    eccoSA: false,
    withOffice: false,
    provId: "12",
    onlyThisLocalities: []
  },
  {
    value: "G",
    label: "Santiago del Estero",
    officeName: "Santiago del Estero",
    eccoSA: false,
    withOffice: false,
    provId: "23",
    onlyThisLocalities: []
  },
  {
    value: "H",
    label: "Chaco",
    officeName: "Chaco",
    eccoSA: false,
    withOffice: false,
    provId: "4",
    onlyThisLocalities: []
  },
  {
    value: "J",
    label: "San Juan",
    officeName: "San Juan",
    eccoSA: false,
    withOffice: false,
    provId: "19",
    onlyThisLocalities: []
  },
  {
    value: "K",
    label: "Catamarca",
    officeName: "Catamarca",
    eccoSA: false,
    withOffice: false,
    provId: "3",
    onlyThisLocalities: []
  },
  {
    value: "L",
    label: "La Pampa",
    officeName: "La Pampa",
    eccoSA: false,
    withOffice: false,
    provId: "11",
    onlyThisLocalities: []
  },
  {
    value: "N",
    label: "Misiones",
    officeName: "Misiones",
    eccoSA: false,
    withOffice: false,
    provId: "14",
    onlyThisLocalities: []
  },
  {
    value: "P",
    label: "Formosa",
    officeName: "Formosa",
    eccoSA: false,
    withOffice: false,
    provId: "9",
    onlyThisLocalities: []
  },
  {
    value: "U",
    label: "Chubut",
    officeName: "Chubut",
    eccoSA: false,
    withOffice: false,
    provId: "5",
    onlyThisLocalities: []
  },
  {
    value: "V",
    label: "Tierra del fuego",
    officeName: "Tierra del fuego",
    eccoSA: false,
    withOffice: false,
    provId: "24",
    onlyThisLocalities: []
  },
  {
    value: "W",
    label: "Corrientes",
    officeName: "Corrientes",
    eccoSA: false,
    withOffice: false,
    provId: "7",
    onlyThisLocalities: []
  },
  {
    value: "Y",
    label: "Jujuy",
    officeName: "Jujuy",
    eccoSA: false,
    withOffice: false,
    provId: "10",
    onlyThisLocalities: []
  },
  {
    value: "Z",
    label: "Santa Cruz",
    officeName: "Santa Cruz",
    eccoSA: false,
    withOffice: false,
    provId: "21",
    onlyThisLocalities: []
  }
].sort((a, b) => (a.label > b.label ? 1 : -1));

export default info_provinces;
